export default "__VITE_ASSET__CkKD8lFD__"